import React from "react"
import GoogleMapReact from "google-map-react"

import { withMap } from "./withMap"
import { GOOGLE_MAP_STYLE } from "./MapStyles"
import MapMarker from "./MapMarker"

const Map = withMap(
  ({ googleMapKey, location, handleMarkerClick, handleMarkerClose, storesData, additionalViewDetailLinkText, disableInfoWindow }) => {
    return (
      <GoogleMapReact
        bootstrapURLKeys={{ key: googleMapKey }}
        defaultCenter={location}
        center={location}
        defaultZoom={11}
        options={{
          scrollwheel: false,
          styles: GOOGLE_MAP_STYLE,
        }}
        onChildClick={handleMarkerClick}
      >
        {storesData.map(store => (
          <MapMarker
            key={store?.id}
            lat={store?.location?.lat}
            lng={store?.location?.lng}
            store={store}
            onClose={handleMarkerClose}
            additionalViewDetailLinkText={additionalViewDetailLinkText}
            disableInfoWindow={disableInfoWindow}
          />
        ))}
      </GoogleMapReact>
    )
  }
)

export default Map
